import { PermissionValues } from '../../auth/permissionValues';

export const isAssetReadOnly = (account: any, workspaceAsset: any): boolean => {
  if (!account || !workspaceAsset) {
    return true;
  }

  return !account.hasPermission(PermissionValues.asset.update);
};
